import { render, staticRenderFns } from "./StartView.html?vue&type=template&id=4e892f40&"
import script from "./StartView.vue?vue&type=script&lang=ts&"
export * from "./StartView.vue?vue&type=script&lang=ts&"
import style0 from "./StartView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports